import cls from './Bar.module.scss';
import arrowImg from '../../shared/assets/images/arrow.svg';
import childPurpleImg from '../../shared/assets/images/game/children/purple_head.svg';
import childBlueImg from '../../shared/assets/images/game/children/blue_head.svg';
import childOrangeImg from '../../shared/assets/images/game/children/orange_head.svg';
import childPinkImg from '../../shared/assets/images/game/children/pink_head.svg';
import childGreyImg from '../../shared/assets/images/game/children/grey_head.svg';
import childYellowImg from '../../shared/assets/images/game/children/yellow_head.svg';
import Hooks from '../../shared/ui/Hooks/Hooks';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../shared/redux/store';
import { useEffect } from 'react';
import { replishCharge } from '../../shared/redux/game/slice';
import wrongMp3 from '../../shared/assets/sound/wrong_1.mp3';
import { Howl } from 'howler';
import { propsChild } from '../../shared/redux/child/types';

const soundEndCharge = new Howl({
  src: [wrongMp3],
});

const Bar = () => {
  const { charge } = useSelector((state: RootState) => state.game);
  const { lastClickTime } = useSelector((state: RootState) => state.hooks);
  const { endGame } = useSelector((state: RootState) => state.pages);
  const children = useSelector((state: RootState) => state.children.children);
  const isSound = useSelector((state: RootState) => state.sound.isSound);
  const dispatch = useDispatch();

  useEffect(() => {
    const interval = setInterval(() => {
      if (Date.now() - lastClickTime > 1000) {
        if (!endGame) {
          dispatch(replishCharge());
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [lastClickTime, endGame]);

  useEffect(() => {
    if (charge === 0 && isSound) {
      soundEndCharge.play();
    }
  }, [charge]);

  const getStyle = (isDied: boolean) => {
    if (isDied) {
      return { filter: 'grayscale(1)' };
    } else {
      return {};
    }
  };

  return (
    <div className={cls.Bar}>
      <div className={cls.progress} style={{ width: `calc(${charge} * 1.74px)` }}></div>
      <img alt="Arrow" src={arrowImg} className={cls.arrowImage} />
      <div className={cls.childrenGroup}>
        <img alt="Child" src={childBlueImg} style={getStyle(children[0].isDied)} />
        <img alt="Child" src={childOrangeImg} style={getStyle(children[1].isDied)} />
        <img alt="Child" src={childPurpleImg} style={getStyle(children[2].isDied)} />
        <img alt="Child" src={childPinkImg} style={getStyle(children[3].isDied)} />
        <img alt="Child" src={childGreyImg} style={getStyle(children[4].isDied)} />
        <img alt="Child" src={childYellowImg} style={getStyle(children[5].isDied)} />
      </div>
      <Hooks />
    </div>
  );
};

export default Bar;
